import { useSceneEntities } from "@/stores/SceneEntities";
import { useAssetGrabbarsValidate } from "@/scripts/rooms/actions/alcove/AssetGrabbarsValidate";
import { useAssetAccentValidate1 } from "@/scripts/rooms/actions/alcove/AssetAccentValidate1";
export function useAssetRecessSoap1Window(payload, viewport) {
  
  const sceneEntities = useSceneEntities();
  let wallsfull = sceneEntities.getUIData("wallsfull").enabled;
  let walls34 = sceneEntities.getUIData("walls34").enabled;
  let asset = null;
  if (wallsfull) {
    asset = sceneEntities.configuratorView.viewportComponent.getViewportAsset("wall_interior_center_full_soap_1_window");
  }
  if (walls34) {
    asset = sceneEntities.configuratorView.viewportComponent.getViewportAsset("wall_interior_center_34_soap_1_window");
  }

  let asset2 =  sceneEntities.configuratorView.viewportComponent.getViewportAsset("accessories_soap1");
  let asset3 =  sceneEntities.configuratorView.viewportComponent.getViewportAsset("window");

  if (asset) {
    asset.enabled = payload.enabled;
    viewport.setEnabled(asset);

    asset2.enabled = payload.enabled;
    viewport.setEnabled(asset2);

    asset3.enabled = payload.enabled;
    viewport.setEnabled(asset3);
  }
  useAssetGrabbarsValidate(null,viewport)
  useAssetAccentValidate1(null,viewport)
}
